import { createSelector } from 'reselect';
import { selectProperties } from 'core/selectors/user';

// properties
export const selectCardBarclaysIndicator =
  createSelector(selectProperties, properties => properties?.cardBarclaysIndicator);
export const selectCardCitiIndicator =
  createSelector(selectProperties, properties => properties?.cardCitiIndicator);
